const Button = ({
  children,
  variant = "primary",
  size = "medium",
  onClick,
  disabled,
  type = "button",
  className = "",
  ...props
}) => {
  let variantClass = "btn-primary";
  switch (variant) {
    case "secondary":
      variantClass = "btn-secondary";
      break;
    case "success":
      variantClass = "btn-success";
      break;
    case "danger":
      variantClass = "btn-danger";
      break;
    case "warning":
      variantClass = "btn-warning";
      break;
    case "info":
      variantClass = "btn-info";
      break;
    case "light":
      variantClass = "btn-light";
      break;
    case "dark":
      variantClass = "btn-dark";
      break;
    case "close":
      variantClass = "btn-close";
      break;
    default:
      variantClass = "btn-primary";
  }

  let sizeClass = "";
  switch (size) {
    case "small":
      sizeClass = "btn-sm";
      break;
    case "large":
      sizeClass = "btn-lg";
      break;
    default:
      break;
  }

  return (
    <button
      className={`btn ${variantClass} ${sizeClass} ${className}`}
      onClick={onClick}
      type={type}
      disabled={disabled}
      {...props}
    >
      {children}
    </button>
  );
};

export default Button;
